import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CoreApiService} from "../../service/core-api.service";
import {Router} from "@angular/router";
import {AuthService} from "../../service/auth.service";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {
  ForgotPasswordDto,
  ForgotPasswordOptionEnum,
  ForgotPasswordOtpOptionDto,
  ForgotPasswordRequestDto,
} from "../../../rg/types/registration.types";
import {CoreComponent} from "../core-component/core.component";
import {FormGroup} from "@angular/forms";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {MessageHelper} from "../../helper/message-helper";
import {AppMessageService} from "../../service/app-message.service";

@Component({
  selector: 'forget-password-request',
  templateUrl: './forget-password-request.component.html',
  styleUrls: ['./forget-password-request.component.css']
})
export class ForgetPasswordRequestComponent extends CoreComponent implements OnInit, OnDestroy {

  @Input() formGroup!: FormGroup | undefined;
  @Output() onStepComplete = new EventEmitter<number>;

  visible: boolean = false;

  forgotPasswordDto: ForgotPasswordDto | undefined;
  selectedOption: ForgotPasswordOptionEnum | undefined;

  constructor(
    protected registrationApiService: RegistrationApiService,
    protected signUpService: SignUpService,
    protected messageService: AppMessageService,
    protected coreApiService: CoreApiService,
    protected router: Router) {
    super();
  }

  override ngOnInit(): void {
    this.initComponent();

  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  showDialog() {
    this.visible = true;
  }

  /**
   * Destroy component.
   */
  override ngOnDestroy(): void {

  }

  handleForgotPassword() {
    this.busy = true;
    const dto: ForgotPasswordRequestDto = {
      anyUserText: this.formGroup?.get('anyUserText')?.value,
      deviceInfo: this.coreApiService.getDeviceInfo(),
    }

    this.registrationApiService.requestForgotPasswordOptions(dto).subscribe((res: ForgotPasswordDto) => {
      this.signUpService.phoneNumber = dto.anyUserText;
      this.forgotPasswordDto = res;
      this.selectedOption = this.forgotPasswordDto.options[0].type;

      this.busy = false;
      this.showDialog();
    }, error => {
      this.formGroup?.get('anyUserText')?.setErrors({notFound: error.error.data});
      this.busy = false;
    })
  }

  handleRequestOtp() {
    this.busy = true;
    if (this.selectedOption == ForgotPasswordOptionEnum.email || this.selectedOption == ForgotPasswordOptionEnum.phone) {

      this.signUpService.selectedOtpOption = this.selectedOption;

      if (this.selectedOption == ForgotPasswordOptionEnum.email) {
        const foundOption = this.forgotPasswordDto?.options.find(option => option.type === ForgotPasswordOptionEnum.email);
        this.signUpService.phoneNumber = foundOption?.value;
      } else {
        const foundOption = this.forgotPasswordDto?.options.find(option => option.type === ForgotPasswordOptionEnum.phone);
        this.signUpService.phoneNumber = foundOption?.value;
      }

      const dto: ForgotPasswordRequestDto = {
        anyUserText: this.formGroup?.get('anyUserText')?.value,
        selectedOption: this.selectedOption,
        deviceInfo: this.coreApiService.getDeviceInfo(),
      }

      this.registrationApiService.requestForgotPasswordOtp(dto).subscribe(res => {
        this.handleStepComplete();
        this.busy = false;
      }, error => {
        MessageHelper.showErrorMessage(error.error.data, this.messageService)
        this.busy = false;
      });
    }

  }

  handleStepComplete() {
    this.onStepComplete.emit(1);
  }

  navigateToLogin() {
    this.router.navigate(['/login'])
  }

  protected readonly ForgotPasswordOptionEnum = ForgotPasswordOptionEnum;
}
